export default __webpack_public_path__ + "static/media/solar-panel-solid.e653e127.svg";